import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { getMapKey } from '@/lib/utils';

export interface InviteCardState {
    styleList: {
        [activityId_type: string]: number[];
    };
    card: {
        [mapKey_activityId_teamId_styleId: string]: string | Promise<any> | undefined;
    };
}

const m: Module<InviteCardState, RootState> = {
    namespaced: true,
    state: {
        styleList: {},
        card: {},
    },
    mutations: {
        setStyleList(state, { key, result }) {
            Vue.set(state.styleList, key, result);
        },
        setCard(state, { key, url }) {
            Vue.set(state.card, key, url);
        },
    },
    actions: {
        /**
         * 获取样式列表
         */
        async getStyleList(context, { activityId, type }) {
            const response = await Vue.axios.get('/api/v1/invite_card/style_list', {
                params: {
                    id: activityId,
                    type,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setStyleList', {
                    key: [ activityId, type ].join('_'),
                    result: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 获取邀请卡。有缓存
         */
        async getCard(context, data: { activityId: number; teamId?: number; styleId: number }) {
            const key = getMapKey(data);
            const card = context.state.card[key];
            if (card) {
                return card;
            }
            const promise = Vue.axios.get('/api/v1/invite_card/card', {
                params: {
                    id: data.activityId,
                    style: data.styleId,
                    team_id: data.teamId,
                },
            });
            context.commit('setCard', { key, url: promise });
            const response = await promise;
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setCard', {
                    key,
                    url: rdata.data,
                });
            } else {
                context.commit('setCard', { key, url: undefined });
            }
            return rdata;
        },
    },
};

export default m;
